@use '~/theme/theme' as *;
@use '~/theme/typography';

.outer {
  display: inline-block;
  overflow: hidden;
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  text-align: left;

  &[data-focus-visible] {
    outline: 2px solid color(violet-600);
    outline-offset: 2px;

    @include border-radius(xl);
  }
}

.container {
  background: var(--background, #{color(violet-200)});
  color: var(--color, #{color(grey-800)});

  @include border-radius(xl);

  display: flex;
  align-items: center;

  &.isDisabled {
    --background: #{color(grey-100)};
    --color: #{color(grey-500)};
  }
}

.clickable {
  cursor: pointer;

  &:not(:has(.icon:hover)):hover {
    background: var(--background-hovered, color-mix(in srgb, var(--background) 100%, color(grey-800) 8%)) !important;
    color: var(--color-hovered, var(--color, #{color(grey-800)})) !important;
  }
}

.icon:hover {
  background: var(--background-hovered, color-mix(in srgb, var(--background) 100%, color(grey-800) 8%));

  @include border-radius(xl);
}

.smallRound {
  @include border-radius(sm);
}

.small {
  height: 32px;
  padding: 0 spacing(1.5);
  gap: spacing(1.5);

  @include typography.caption;
  @include typography.medium;

  .icon {
    @include icon-size(sm);
  }
}

.medium {
  height: 38px;
  padding: 0 spacing(1.5);
  gap: spacing(1.5);

  @include typography.body2;
  @include typography.regular;

  .icon {
    @include icon-size(sm);
  }
}

.large {
  height: 48px;
  padding: 0 spacing(2);
  gap: spacing(2);

  @include typography.body1;
  @include typography.regular;

  .icon {
    @include icon-size(md);
  }
}

.label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.iconContainer {
  display: flex;
  align-items: center;
  cursor: pointer;
}
